<template>
  <b-container fluid>
    <PortalNavbar show="true"></PortalNavbar>

    <vue-flux
      style="height:300px"
      :options="fluxOptions"
      :images="fluxImages"
      :transitions="fluxTransitions"
      id="flux"
      ref="slider"
    >
      <flux-pagination slot="pagination"></flux-pagination>
    </vue-flux>
    <!-- Md Tofiq (B) 28-2-19 -->
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img class="d-block w-100" src="@/assets/images/slider-66.jpg" alt="First slide" />
        </div>
        <div class="carousel-item">
          <img class="d-block w-100" src="@/assets/images/slider-33.jpg" alt="Second slide" />
        </div>
        <div class="carousel-item">
          <img class="d-block w-100" src="@/assets/images/slider-44.jpg" alt="Third slide" />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleControls"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleControls"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="m-3">
            <span>
        <h5 style="color:red;" class="m-3">
          Uniform of the Guards are changed as per Government order. The details of the uniform are as per attached file... <a href="https://s3.ap-south-1.amazonaws.com/sgbregistration.in/SGBPDF01052025.pdf"  target="_blank">Click Here.</a>
        </h5>
      </span>

      <!-- सुरक्षा रक्षक मंडळ बृहन्मुंबई आणि ठाणे जिल्हा यांचे कडून असे सूचित करण्यांत येते की,दिंनांक ०७ ऑगस्ट २०२३ रोजी,  मंडळाच्या नोंदणी पोर्टलवरुन नोंदणीसंदर्भात आय.टी. डिपार्टमेंटकडून अनावधानाने काही मेसेज निर्गमित झाले असून ज्यांना सदर मॅसेज प्राप्त झाले आहेत त्यांनी त्याची नोंद घेऊ नये तसेच यासंदर्भात मंडळाशी संपर्क साधू नये.
    आदेशावरुन -->
         <!-- पुणे जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय पुल-२०१९ तयार करणेसाठीच्या जाहिरातीस अनुसरून, पात्र / योग्य ठरलेल्या उमेदवारांना कळवण्यात येत आहे कि, 
         आपले चारित्र्य पडताळणी प्रमाणपत्र आणि आरोग्य चाचणी प्रमाणपत्र ऑनलाईन सादर करण्याची मुदत दिनांक ३१ मे २०२२ पर्यन्त वाढविण्यात आली आहे. 
         त्यानंतर सादर केलेली प्रमाणपत्र ग्राह्य धरली जाणार नाहीत याची सर्वांनी नोंद घ्यावी तसेच मुदत संपल्यावर कोणत्याही सबबीचा विचार केला जाणार नाही. -->
         <!-- जाहिर सूचना </br> -->
    <!-- अमरावती जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय पुल-२०२१ तयार करणेसाठीच्या जाहिरातीस अनुसरून, मैदानी परीक्षेस उपस्थित झालेल्या सर्व उमेदवारांना त्यांच्या प्रोफाईल वरती मैदानी परीक्षेत मिळालेले गुण, शैक्षणिक अहर्ता व गुण व इतर माहिती उपलब्ध करून देण्यात आलेली आहे. उमेद्वारांनी www.sgbregistration.in या संकेतस्थळावर जाऊन स्व:ताचे User ID आणि password टाकून प्रथम Login करावे , तद्नंतर My Account  >> View Result वर click करून उमेदवारास पाठवलेले शाररीक व मैदानी परीक्षेत प्राप्त गुण, अर्जात नमूद केलेले शैक्षणिक अहर्ता, तपासून घ्यावे. त्यात उमेदवारास काही शंका/आक्षेप असल्यास amt_sgboard@rediffmail.com  या इमेल आयडी वर, किंवा सचिव, अमरावती जिल्हा सुरक्षा रक्षक मंडळ, परांजपे कॉलनी, डॉ. पुंडकर प्लॉट, आर. टि. ओ. कार्यालय मागे, अमरावती - ४४४६०२ या पत्तावर दिनांक १०/१०/२०२२ पर्यंत पोहचतील असे पाठवावेत. त्यानंतर प्राप्त अर्जावर कोणती हि दखल घेतली जाणार नाही. 
	  सदर समुच्चय पुल तयार करणे हि थेट भरती नाही. त्यामुळे समुच्चय पुलासाठी पात्र उमेदवारांना नोकरीतील हमी देता येत नाही. मात्र ज्या प्रमाणात अस्थापानांकडून मागणी उपलब्ध होईल, त्यानुसार समुच्चय पुलावरील उमेदवारांना कामासाठी वितरीत केले जाईल.
	  सदर समुच्चय पुल तयार करणेचे काम पूर्णपणे पारदर्शक पद्धतीने राबविण्यात आले असून उमेदवारांनी कोणत्याही त्रयस्थ व्यक्ती एजंट/दलाल यांच्याशी आर्थिक व्यवहार आणि संपर्क करू नये. असे आवाहन करण्यात येत आहे. -->
      
      
      <!-- <p style="color:red;" class="m-3">
        पुणे जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय पुल-२०१९ तयार करणेसाठीच्या जाहिरातीस अनुसरून, पात्र / योग्य ठरलेल्या उमेदवारांच्या गुणांचा आरक्षणनिहाय तपशील (कट ऑफ ) <a href="/#/punenotice">सदर लिंक</a> वर प्रसिद्ध केला आहे. उमेदवारांनी याची नोंद घ्यावी.
	      सदर समुच्चय पुल तयार करणे हि थेट भरती नाही. त्यामुळे समुच्चय पुलासाठी पात्र उमेदवारांना नोकरीतील हमी देता येत नाही. मात्र ज्या प्रमाणात अस्थापानांकडून मागणी उपलब्ध होईल, त्यानुसार समुच्चय पुलावरील उमेदवारांना कामासाठी वितरीत केले जाईल.
	      सदर समुच्चय पुल तयार करण्याची प्रक्रिया पूर्णपणे पारदर्शक पद्धतीने राबविण्यात आली असून उमेदवारांनी कोणत्याही व्यक्ती एजंट/दलाल यांच्याशी आर्थिक व्यवहार आणि संपर्क करू नये. असे आवाहन करण्यात येत आहे.
      </p> -->
      <!-- <p style="color:blue;font-weight:bold" class="m-3">
        चंद्रपूर जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय (pool) तयार  करण्या करिता ज्या अर्जदारांनी निवडीसाठी आवेदनपत्र सादर केली आहेत त्यांच्याकरिता - सादर निवड प्रक्रियेमध्ये एकूण ७ टप्पे असून त्या पैकी पहिला टप्पा "मूळ कागदपत्र पडताळणी"दिनांक ०७ डिसेंबर २०२१ पासून सुरू होत आहे. अर्जदाराना त्यांचे हजर राहण्याचा दिनांक व वेळ SMS द्वारे कळविण्यात येईल. तसेच sgbregistraion.in या संकेत स्थळावर दररोज ज्या अर्जांची पडताळणी केली जाणार आहे त्याचे वेळापत्रक <a href="/#/schedule">Schedule</a> या मेनू मध्ये सादर केले जाईल. तरी अर्जदारानी या वेळापत्रका प्रमाणे आपल्या नेमून दिलेल्या वेळेत हजर राहून आपली कागदपत्रे पाडताळून घ्यावीत.  अर्ज पडताळणीचे  ठिकाण - स्टील अथॉरिटी ऑफ इंडिया लिमिटेड, चंद्रपूर फेरो अलॉय, मुल रोड बंगाली कॅम्प चंद्रपूर. उमेदवारांनी अर्ज पडताळणीसाठी येताना सोबत ऑनलाईन सादर केलेले सर्व कागदपत्राची मूळप्रत,सर्वांची छायांकितप्रत आणि आवेदनपत्र प्रत स्वतः घेऊन येणे आवश्यक आहे.
      </p> -->
      <!-- <p style="color:blue;font-weight:bold" class="m-3">
        अमरावती जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय (pool) तयार  करण्या करिता ज्या अर्जदारांनी निवडीसाठी आवेदनपत्र सादर केली आहेत त्यांच्याकरिता  - सादर निवड प्रक्रियेमध्ये एकूण ७ टप्पे असून त्या पैकी पहिला टप्पा "मूळ कागदपत्र पडताळणी"दिनांक २३ सप्टेंबर २०२१ पासून सुरू होत आहे. अर्जदाराना त्यांचे हजर राहण्याचा दिनांक व वेळ SMS द्वारे कळविण्यात येईल. तसेच sgbregistraion.in या संकेत स्थळावर दररोज ज्या अर्जांची पडताळणी केली जाणार आहे त्याचे वेळापत्रक <a href="/#/schedule">Schedule</a> या मेनू मध्ये सादर केले जाईल. तरी अर्जदारानी या वेळापत्रका प्रमाणे आपल्या नेमून दिलेल्या वेळेत हजर राहून आपली कागदपत्रे पाडताळून घ्यावीत.  अर्ज पडताळणीचे  ठिकाण - कामगार कल्याण मंडळ ललितकला भवन, छाबडा प्लॉट प्रशांत नगर.  उमेदवारांनी अर्ज पडताळणीसाठी येताना सोबत ऑनलाईन सादर केलेले सर्व कागदपत्राची मूळप्रत,सर्वांची छायांकितप्रत आणि आवेदनपत्र प्रत स्वतः घेऊन येणे आवश्यक आहे.
      </p> -->
      <!-- <p style="color:blue;font-weight:bold" class="m-3">
        सांगली जिल्हा सुरक्षा रक्षक मंडळ नवीन सुरक्षा रक्षक समुच्चय पुल 2019 मधील उमेदवारांना त्यांचे अंतिम गुण त्यांचा sgbregistration.in पोर्टल वरील वैयक्तिक खात्यावर पाठवण्यात आले आहेत.
        <br />सदर भरती प्रक्रियेस अनुसरून उमेदवारांची शारीरिक चाचणी/मैदानी परीक्षा, शैक्षणिक पात्रतेबाबत व भरतीस अनुसरून इतर अनुषंगिक मुद्यांबाबत काहिही आक्षेप असल्यास दिनांक ०३/०३/२०२१ पर्यंत helpdesk.sgb@gmail.com या इमेल आयडिवर अथवा सांगली जिल्हा सुरक्षा रक्षक मंडळ, वसंत मार्केटयार्ड, सांगली येथे लेखी अर्ज सादर करावा.
      </p>-->
      <!-- <p style="color:blue;font-weight:bold" class="m-3">
        रायगड जिल्हा सुरक्षा रक्षक मंडळ सर्व पात्र उमेदवारांना कळवण्यात येत आहे कि, आपले चारित्र्य पडताळणी प्रमाणपत्र आणि आरोग्य चाचणी प्रमाणपत्र ऑनलाईन सादर करण्याची शेवटची तारीख दिनांक ३० ऑक्टोंबर २०२० आहे. त्यानंतर सादर केलेल्या प्रमाणपत्र ग्राह्य धरले जाणार नाही.याची सर्वांनी नोंद घ्यावी तसेच मुदत संपल्यावर कोणत्याही सबबीचा विचार केला जाणार नाही.
      </p>-->
      <!-- <p style="color:red;font-weight:bold" class="m-3">
        जाहीर आवाहन 
"पुणे जिल्हा सुरक्षा रक्षक मंडळाकडून सुरक्षा रक्षकांचा समुच्चय पुल तयार करण्यासाठी दि. ०८/०७/२०१९ रोजी वर्तमान पत्रात जाहिरात देण्यात आली होती. सदर समुच्चय पुल प्रक्रीयेसाठी उमेदवारांची कागदपत्रांची पडताळणी करून शाररीक व मैदानी चाचणी घेण्यात आली असून, लवकरच अंतिम निकाल जाहीर केला जाणार आहे. सदर समुच्चय पुल प्रक्रीया शासन निर्णयानुसार पूर्णपणे पारदर्शक पद्धतीने राबविण्यात आली असून उमेदवारांनी कुठल्याही व्यक्ती अथवा एजंट यांच्याशी आर्थिक पैशांचा व्यवहार केल्यास त्याला पुणे जिल्हा सुरक्षा रक्षक मंडळ जबाबदार राहणार नाही. तसेच उमेदवारांस कोणी व्यक्ती अथवा एजंट परस्पर मंडळाच्या नावे पैसे उकळणे किंवा फसवणूक करणे इत्यादी बाबी आढळल्यास मंडळाच्या इमेल आयडीवर (pdsgbpune@gmail.com)/ पोलीस विभाग यांच्याशी संपर्क करावा."
      </p>-->
      <!-- <p style="color:red;font-weight:bold" class="m-3">रायगड जिल्हातील सर्व उमेदवारांना आवाहन करण्यात येते कि, सदरची प्रतीक्षा यादी तयार करण्याची प्रक्रिया पुर्णत: संगणीकृत व ऑनलाईन आहे. या मध्ये कोणताही मानवी हस्तक्षेप नाही. त्यामुळे उमेदवारांनी कोणत्याही दलालांशी संपर्क करू नये, अथवा अमिशांना बळी पडू नये. फसवणूक झाल्यास मंडळ जबाबदार राहणार नाही. याची नोंद घ्यावी.</p> -->
    </div>
    <div style="background-color:white;">
      <marquee class="mt-3">
        <p v-for="msg in scrollMessages" :key="msg" v-html="msg"></p>
      </marquee>
    </div>
    <!-- Md(E)   -->
    <StatComponent></StatComponent>
    <section class="about_us_area row">
      <b-container fluid>
        <div
          class="row about_row"
          style="padding-top:0px; padding-top: 40px;padding-left:15px; padding-right:15px;"
        >
          <div class="col-md-6">
            <div class="panel panel-primary crc-panel">
              <div class="panel-heading">
                <h3 class="panel-title">Job Postings</h3>
              </div>
              <div class="panel-body containerM" style="height:200px;">
                <div class="bs-example marquee" data-example-id="default-media">
                  <div class="media">
                    <div class="media-body">
                      <h4 v-for="msg in scrollMessages" :key="msg" class="mt-3">
                        <li v-html="msg"></li>
                      </h4>

                      <h4 class="media-heading">&nbsp;</h4>

                      <h4
                        class="media-heading"
                      >Beware of Fraudulent persons offering jobs at Security Guards Board.</h4>
                      <!-- <p style="color:red"><strong>मंडळात नवीन पदांसाठी कोणतीही भरती वा नोंदणी प्रक्रिया सुरु नाही.</strong></p> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="panel panel-info-crc crc-panel">
              <div class="panel-heading">
                <h3 class="panel-title">News & Events</h3>
              </div>
              <div class="panel-body containerM" style="padding:0px; height:200px;">
                <ul class="list-group marquee">
                  <li class="list-group-item">
                    <b>
                      <a
                        target="_blank"
                        href="http://securityguardsboard.in/images/pdf/WAGESCIRCULARJUL18.pdf"
                        class="newsnevents"
                      >Wages circular of security guards</a>
                    </b>
                  </li>
                  <li class="list-group-item">
                    <b>
                      <a
                        target="_blank"
                        href="http://securityguardsboard.in/images/pdf/tds-certificate-18-19.pdf"
                      >TDS Certificate 2018-19</a>
                    </b>
                  </li>
                  <li class="list-group-item">
                    <b>
                      <a
                        target="_blank"
                        href="http://securityguardsboard.in/images/pdf/daincreasesenglish.pdf"
                      >English Wages Circular Of Jan 2018 To 30 Jun 2018</a>
                    </b>
                  </li>
                  <li class="list-group-item">
                    <b>
                      <a
                        target="_blank"
                        href="http://securityguardsboard.in/images/pdf/daincreasesmarathi.pdf"
                      >Marathi Wages Circular Of Jan 2018 To 30 Jun 2018</a>
                    </b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div id="guide" class="panel panel-info-crc2 crc-panel">
              <div class="panel-heading">
                <h3 class="panel-title">Guidelines for Candidate</h3>
              </div>
              <!-- <div class="containerM">
              <div class="panel-body marquee" style="padding: 0px; height:200px;">-->
              <div class="panel-body containerM" style="padding:0px; height:200px;">
                <ul class="list-group marquee">
                  <!-- <li class="list-group-item"><b><a href="https://s3.ap-south-1.amazonaws.com/sgbregimages/Instructions.pdf" target="_blank">Instruction Set for Online Application Process</a></b></li> -->
                  <li class="list-group-item">
                    <b>
                      <a
                        href="https://s3.ap-south-1.amazonaws.com/sgbregistration.in/Instructions.pdf"
                        target="_blank"
                      >Instruction Set for Online Application Process</a>
                    </b>
                  </li>
                  <li class="list-group-item">
                    <b>
                      <a
                        href="https://s3.ap-south-1.amazonaws.com/sgbregimages/Popup_Blocker_Guidance.pdf"
                        target="_blank"
                      >Pop Up Blocker Guidance</a>
                    </b>
                  </li>
                  <li class="list-group-item">
                    <b>
                      <a
                        href="https://s3.ap-south-1.amazonaws.com/sgbregimages/Forgot_Password.pdf"
                        target="_blank"
                      >Forgot Password</a>
                    </b>
                  </li>
                  <li class="list-group-item">
                    <b>
                      <a
                        href="https://s3.ap-south-1.amazonaws.com/sgbregimages/PhotoandSignature.pdf"
                        target="_blank"
                      >Instruction for Croping Photos</a>
                    </b>
                  </li>
                </ul>
              </div>
              <!-- </div>
              </div>-->
            </div>
          </div>
        </div>
      </b-container>
    </section>
    <!-- <section class="professional_builder row" style="padding-top: 0px;">
        <div class="container">
          <div class="row builder_all">
            <div class="col-md-4 col-sm-6 builder">
                <img src="../assets/images/CM.jpg" alt="" height="200">
                <h4 style="padding-bottom:10px; padding-top:10px;">Shri. Devendra Fadanvis</h4>
                <p>Hon'ble Chief Minister<br>
                    Government of Maharashtra </p>
            </div>
            <div class="col-md-4 col-sm-6 builder">
                <img src="../assets/images/Sambhajirao.jpg" alt="" height="200">
                <h4 style="padding-bottom:10px; padding-top:10px;">Shri. Sambhajirao Nilangekar</h4>
                <p>Hon'ble Labour Minister<br>
                    Government of Maharashtra </p>
            </div>
            <div class="col-md-4 col-sm-6 builder">
                <img src="../assets/images/stateminister.jpg" alt="" height="200">
                <h4 style="padding-bottom:10px; padding-top:10px;">Shri Vijay Deshmukh</h4>
                <p>Hon'ble State Labour Minister<br>
                    Government of Maharashtra </p>
            </div>
          </div>
        </div>
    </section>-->

    <section class="about_us_area row">
      <div class="container">
        <!--<div class="tittle wow fadeInUp">
              <h2>ABOUT US</h2>
              <h4>Lorem Ipsum is simply dummy text of the printing and typesetting industry</h4>
        </div>-->
        <div class="row about_row">
          <div class="who_we_area col-md-7 col-sm-6">
            <div class="subtittle">
              <h2 style="color:#ec5624;">About us</h2>
            </div>
            <p class="mr-5">
              During the year 1980-81, the Maharashtra Rajya Suraksha Rakshak and General Kamgar Union had represented to Government that about 70,000 persons are working as Security Guards in various Factories and Establishments in Greater Bombay and Thane District. These Guards are provided by Security Agencies operating in these Areas. The service conditions, however of these Security Guards are not satisfactory and these Security Guards are being exploited in as much as that their services depend merely on the whim and sweetwill of the Agencies. Most of the Security Guards receive very small portion of the amount recovered from the Employers as their wages and the balance is pocketed by the Agencies.
              The Government therefore conducted a rapid survey through the Office of the Commissioner of Labour and the findings of the said survey confirmed that there is substantial truth in the representation. It was also noticed that the Security Guards were not entitled to any protection of the Labour Laws available to the other workers of the Factories and Establishments.
              <br />
              <a href="about.html" class>Read More...</a>
            </p>
          </div>
          <!--<div class="col-md-5 col-sm-6 about_client">
                  <img src="images/about_client.jpg" alt="">
          </div>
          <div class="col-md-1 widget_area">
            <img src="../assets/images/guards.jpg" id="aboutimg" style="padding-top: 100px;" />
          </div>-->
        </div>
      </div>
    </section>
    <section class="our_feature_area">
      <div class="container">
        <!--<div class="tittle wow fadeInUp">
                <h2>Our Features</h2>
                <h4>Lorem Ipsum is simply dummy text of the printing and typesetting industry</h4>
        </div>-->
        <div class="feature_row row">
          <!--
          <div class="col-md-6 feature_img">
            <img src="../assets/images/guards.jpg" alt style="margin-top:119px;" />
          </div>-->
          <div class="col-md-6 feature_content">
            <div class="subtittle">
              <h2 style="color:#ec5624;">WHY CHOOSE US</h2>
              <!--<h5>There are many variations of passages of Lorem Ipsum available.</h5>-->
            </div>
            <div class="media">
              <div class="media-left">
                <a href="#">
                  <i class="fa fa-certificate" aria-hidden="true"></i>
                </a>
              </div>
              <div class="media-body">
                <a href="#">Goverment Constituted board</a>
                <p>Constituted by Government of Maharashtra in 1981.</p>
              </div>
            </div>
            <div class="media">
              <div class="media-left">
                <a href="#">
                  <i class="fa fa-check" aria-hidden="true" style="border: 5px solid #ccc;"></i>
                </a>
              </div>
              <div class="media-body">
                <a href="#">Authenticity</a>
                <p>Government authentic. Background Verified Guards.</p>
              </div>
            </div>
            <div class="media">
              <div class="media-left">
                <a href="#">
                  <i class="fa fa-users" aria-hidden="true" style="border: 5px solid #135142;"></i>
                </a>
              </div>
              <div class="media-body">
                <a href="#">Expert staff</a>
                <p>Experianced staff, selected by following goverment guidlines</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="our_partners_area">
      <div class="container">
        <div class="tittle wow fadeInUp">
          <h2>Proudly Securing Our Clients</h2>
          <!--<h4>Lorem Ipsum is simply dummy text of the printing and typesetting industry</h4>-->
        </div>
        <!-- <div class="partners"> -->
        <carousel
          :autoplay="true"
          :nav="false"
          :items="5"
          :autoWidth="false"
          :autoHeight="false"
          :margin="50"
        >
          <img src="../assets/images/client_logo/16.jpg" alt />
          <img src="../assets/images/client_logo/1.jpg" alt />
          <img src="../assets/images/client_logo/2.jpg" alt />
          <img src="../assets/images/client_logo/3.jpg" alt />

          <img src="../assets/images/client_logo/4.jpg" alt />
          <img src="../assets/images/client_logo/5.jpg" alt />
          <img src="../assets/images/client_logo/6.jpg" alt />

          <img src="../assets/images/client_logo/7.jpg" alt />
          <img src="../assets/images/client_logo/8.jpg" alt />
          <img src="../assets/images/client_logo/9.jpg" alt />

          <img src="../assets/images/client_logo/10.jpg" alt />
          <img src="../assets/images/client_logo/11.jpg" alt />
          <img src="../assets/images/client_logo/12.jpg" alt />

          <img src="../assets/images/client_logo/13.jpg" alt />
          <img src="../assets/images/client_logo/14.jpg" alt />
          <img src="../assets/images/client_logo/15.jpg" alt />

          <img src="../assets/images/client_logo/5.jpg" alt />
          <img src="../assets/images/client_logo/6.jpg" alt />
          <!-- </div> -->
        </carousel>
      </div>

      <!-- <div class="book_now_aera">
            <div class="container">
                <div class="row book_now">
                    <div class="col-md-10 booking_text">
                        <h4>Booking now if you need build your dream home.</h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <div class="col-md-2 p0 book_bottun">
                        <a href="#" class="button_all">book now</a>
                    </div>
                </div>
            </div>
      </div>-->
    </section>

    <!--  Md Tofiq (B) 28-2-19 -->
    <!-- Footer Area -->
    <footer class="footer_area mt-4">
      <div class="container">
        <div class="footer_row row ml-5">
          <div class="col-md-4 col-sm-6 mb-3 footer_about">
            <img src="@/assets/images/sgb.jpg" width="70" height="70" alt />

            <!-- <ul class="socail_icon">  
                      <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li> 
                      <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
            </ul>-->
          </div>

          <div class="col-md-3 col-sm-6 footer_about quick">
            <h2>Important links</h2>
            <ul class="quick_link">
              <li>
                <a href="/#/preamble">
                  <i class="fa fa-chevron-right"></i>PREAMBLE
                </a>
              </li>
              <li>
                <a href="/#/actscheme">
                  <i class="fa fa-chevron-right"></i>ACT AND SCHEME
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fa fa-chevron-right"></i>RATES WAGES & ALLOWANCES
                </a>
              </li>
              <li>
                <a href="/#/levywages">
                  <i class="fa fa-chevron-right"></i>LEVY ON WAGES
                </a>
              </li>
              <!-- <li><a href="#"><i class="fa fa-chevron-right"></i>OURT JUDGEMENT</a></li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="copyright_area">
        <div class="foot" style="float:left;">
          <a class="ml-5 mr-5" style="color:white;" href="/#/terms">Terms &amp; Conditions</a>
          <a style="color:white;" href="/#/privacy">Privacy</a>
          <a class="ml-5" style="color:white;" href="/#/paymentterms">Payment Terms</a>
        </div>Copyright 2018 All rights reserved by Security Guards Board
      </div>
    </footer>
    <!-- End Footer Area -->
    <!-- Md(E) -->
  </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
import { VueFlux, FluxPagination, Transitions } from "vue-flux";
import StatComponent from "@/components/Portal/StatComponent";
import carousel from "vue-owl-carousel";
import Instructions from "@/components/GuardSurvey/Instructions";
export default {
  components: {
    PortalNavbar,
    VueFlux,
    FluxPagination,
    StatComponent,
    carousel,
  }, 
  data() {
    return {
      fluxOptions: {
        autoplay: true,
      },
      fluxImages: [
        //require("@/assets/images/slider-66.jpg"),
        //require("@/assets/images/slider-33.jpg"),
        require("@/assets/images/slider-44.jpg"),
        require("@/assets/images/slider-44.jpg"),

        //require("@/assets/images/slider-77.jpg"),
      ],
      fluxTransitions: {
        transitionWaterfall: Transitions.transitionWaterfall,
        transitionZip: Transitions.transitionZip,
        transitionBlocks2: Transitions.transitionBlocks2,
      },
      //scrollMessages:[]
      scrollMessages: [
      //  " सुरक्षा रक्षक मंडळ बृहन्मुंबई आणि ठाणे जिल्हा यांचे कडून असे सूचित करण्यांत येते की,दिंनांक ०७ ऑगस्ट २०२३ रोजी,  मंडळाच्या नोंदणी पोर्टलवरुन नोंदणीसंदर्भात आय.टी. डिपार्टमेंटकडून अनावधानाने काही मेसेज निर्गमित झाले असून ज्यांना सदर मॅसेज प्राप्त झाले आहेत त्यांनी त्याची नोंद घेऊ नये तसेच यासंदर्भात मंडळाशी संपर्क साधू नये.आदेशावरुन"

    //  " जाहिर सूचना अमरावती जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय पुल-२०२१ तयार करणेसाठीच्या जाहिरातीस अनुसरून, मैदानी परीक्षेस उपस्थित झालेल्या सर्व उमेदवारांना त्यांच्या प्रोफाईल वरती मैदानी परीक्षेत मिळालेले गुण, शैक्षणिक अहर्ता व गुण व इतर माहिती उपलब्ध करून देण्यात आलेली आहे. उमेद्वारांनी www.sgbregistration.in या संकेतस्थळावर जाऊन स्व:ताचे User ID आणि password टाकून प्रथम Login करावे , तद्नंतर My Account  >> View Result वर click करून उमेदवारास पाठवलेले शाररीक व मैदानी परीक्षेत प्राप्त गुण, अर्जात नमूद केलेले शैक्षणिक अहर्ता, तपासून घ्यावे. त्यात उमेदवारास काही शंका/आक्षेप असल्यास amt_sgboard@rediffmail.com  या इमेल आयडी वर, किंवा सचिव, अमरावती जिल्हा सुरक्षा रक्षक मंडळ, परांजपे कॉलनी, डॉ. पुंडकर प्लॉट, आर. टि. ओ. कार्यालय मागे, अमरावती - ४४४६०२ या पत्तावर दिनांक १०/१०/२०२२ पर्यंत पोहचतील असे पाठवावेत. त्यानंतर प्राप्त अर्जावर कोणती हि दखल घेतली जाणार नाही.सदर समुच्चय पुल तयार करणे हि थेट भरती नाही. त्यामुळे समुच्चय पुलासाठी पात्र उमेदवारांना नोकरीतील हमी देता येत नाही. मात्र ज्या प्रमाणात अस्थापानांकडून मागणी उपलब्ध होईल, त्यानुसार समुच्चय पुलावरील उमेदवारांना कामासाठी वितरीत केले जाईल. सदर समुच्चय पुल तयार करणेचे काम पूर्णपणे पारदर्शक पद्धतीने राबविण्यात आले असून उमेदवारांनी कोणत्याही त्रयस्थ व्यक्ती एजंट/दलाल यांच्याशी आर्थिक व्यवहार आणि संपर्क करू नये. असे आवाहन करण्यात येत आहे."
         //"पुणे जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय पुल-२०१९ तयार करणेसाठीच्या जाहिरातीस अनुसरून, पात्र / योग्य ठरलेल्या उमेदवारांच्या गुणांचा आरक्षणनिहाय तपशील (कट ऑफ ) <a href='/#/punenotice'>सदर लिंक</a> वर प्रसिद्ध केला आहे. उमेदवारांनी याची नोंद घ्यावी.",
       

        //"पुणे जिल्हा सुरमं नवीन सुरक्षा रक्षक समुच्चय पुल मधील उमेदवारांचे अंतिम गुण त्यांचा sgbregistration.in पोर्टल वरील वैयक्तिक खात्यावर पाठवण्यात आले आहेत. काहिही आक्षेप असल्यास दिनांक १५/०१/२०२२  पर्यंत helpdesk.sgb@gmail.com या इमेल आयडिवर अथवा पुणे जिल्हा सुरक्षा रक्षक मंडळ, २९/२ शांतीकुंज, दुसरा मजला, सोमवार पेठ, पुणे- ४११०११ येथे लेखी अर्ज सादर करावा"
        //"चंद्रपूर जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय (pool) तयार  करण्या करिता ज्या अर्जदारांनी निवडीसाठी आवेदनपत्र सादर केली आहेत त्यांच्याकरिता - सादर निवड प्रक्रियेमध्ये एकूण ७ टप्पे असून त्या पैकी पहिला टप्पा 'मूळ कागदपत्र पडताळणी' दिनांक ०७ डिसेंबर २०२१ पासून सुरू होत आहे. अर्जदाराना त्यांचे हजर राहण्याचा दिनांक व वेळ SMS द्वारे कळविण्यात येईल. तसेच sgbregistraion.in या संकेत स्थळावर दररोज ज्या अर्जांची पडताळणी केली जाणार आहे त्याचे वेळापत्रक <a href='/#/schedule'>Schedule</a> या मेनू मध्ये सादर केले जाईल. तरी अर्जदारानी या वेळापत्रका प्रमाणे आपल्या नेमून दिलेल्या वेळेत हजर राहून आपली कागदपत्रे पाडताळून घ्यावीत.  अर्ज पडताळणीचे  ठिकाण - स्टील अथॉरिटी ऑफ इंडिया लिमिटेड, चंद्रपूर फेरो अलॉय, मुल रोड बंगाली कॅम्प चंद्रपूर. उमेदवारांनी अर्ज पडताळणीसाठी येताना सोबत ऑनलाईन सादर केलेले सर्व कागदपत्राची मूळप्रत,सर्वांची छायांकितप्रत आणि आवेदनपत्र प्रत स्वतः घेऊन येणे आवश्यक आहे."
        //"सांगली जिल्हा सुरक्षा रक्षक मंडळ 'नवीन सुरक्षा रक्षक समुच्चय पुल 2019' मधील उमेदवारांना त्यांचे वैयक्तिक खात्यावर चारित्र्य प्रमाणपत्र आणि वैद्यकीय प्रमाणपत्र यांचा मसुदा पाठविण्यात आला आहे, उमेदवारांनी ऑनलाइन पोर्टल वरील त्यांच्या login नुसार 'MY ACCOUNT >> Intimation Letter' हा मेनू पहावा. उमेदवारानी १० सप्टेंबर २०२१ पर्यन्त चारित्र्य पडताळणी प्रमाणपत्र आणि आरोग्य चाचणी प्रमाणपत्र ऑनलाईन सादर करावे."
        // "सोलापूर जिल्हा सूरमं समुच्चय (पुल) निर्माण प्रक्रिया : मैदानी परीक्षा उत्तीर्ण झालेल्या सर्व अर्जदारांनी पोलीस चारित्र्य प्रमाणपत्र व वैद्यकीय प्रमाणपत्रासाठी लागणारे शिफारस पत्र डाउनलोड करावेत. दोन्ही प्रमाणपत्र 30 दिवसाच्या आत  (11-Oct-2019 पर्यंत) पोर्टलवर अपलोड करावेत",
        // "सांगली जिल्हा सूरमं समुच्चय (पुल) निर्माण प्रक्रिया : ०९ सप्टेंबर २०१९ ते ११ सप्टेंबर २०१९ रोजी उमेदवाराची कागदपत्र पडताळणींचे वेळापत्रक <a href='https://sgbregistration.in/Downloads/Batch_Schedule_Sep2019.pdf' target='_blank'>सदर</a> लिंकवर मिळेल. <a href='https://sgbregistration.in/Downloads/Batch_Schedule_Sep2019.pdf' target='_blank'>Download</a>"
        //"चंद्रपूर - गडचिरोली सुरक्षा रक्षक मंडळाकरिता सुरक्षा रक्षकांचा समुच्चय तयार करण्यासाठी उमेदवारांचे अर्ज मागवण्यात आले आहेत. इच्छुक उमेदवारांनी सदर पुलासाठी या संकेतस्थळावर दिनांक १५ जानेवारी  २०२१ सकाळी ९.०० ते ३० जानेवारी २०२१ सायंकाळी ५.०० वा. पर्यंत अर्ज करावेत. </strong>To Apply <a href='/#/login'>Login</a> or <a href='/#/signup/newapplication'>Signup</a>",
        //"अमरावती जिल्हा ( अमरावती, यवतमाळ, अकोला, वाशिम, बुलडाणा जिल्हाकरिता ) सुरक्षा रक्षक मंडळाकरिता सुरक्षा रक्षकांचा समुच्चय तयार करण्यासाठी उमेदवारांचे अर्ज मागवण्यात आले आहेत. इच्छुक उमेदवारांनी सदर पुलासाठी या संकेतस्थळावर दिनांक १७ जानेवारी २०२१ सकाळी ९.०० ते २६ जानेवारी २०२१ सायंकाळी ५.०० वा. पर्यंत अर्ज करावेत.</strong>To Apply <a href='/#/login'>Login</a> or <a href='/#/signup/newapplication'>Signup</a>"
        // "अमरावती जिल्हा सुरक्षा रक्षक मंडळाकरिता सुरक्षा रक्षकांचा समुच्चय तयार करण्यासाठी उमेदवारांचे अर्ज मागवण्याचा कालावधी वाढवण्यात येत आहे. इच्छुक उमेदवारांनी सदर पुलासाठी दिनांक १० फेब्रुवारी २०२१ सायंकाळी ५.०० वा. पर्यंत अर्ज करावेत."
      ],
    };
  },
  methods: {
    getScrollMessages() {
      let promise = apis.getScrollMessages();
      promise
        .then((response) => {
          //console.log(response);
          if (response.status == 200) {
            this.form = response.body[0];
          }
        })
        .catch((err) => {
          console.log("Error");
        });
    },
  },
};
</script>

<style scoped>
.container {
  width: 100% !important;
}
.panel-heading {
  padding: 18px 15px;
}
.media {
  border-bottom: none;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 1.42857143;
  color: #333;
  padding-bottom: 10px;
  padding-top: 15px;
}
.marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
}

.h4,
h4 {
  font-size: 18px;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }
  100% {
    top: -11em;
  }
}

.header_aera .navbar-collapse .navbar-nav.navbar-right li a {
  margin-top: -15px;
}

.panel-info-crc {
  border-color: #c90c5c;
}

.panel-info-crc > .panel-heading {
  color: #fefefe;
  background-color: #c90c5c;
  border-color: #c90c5c;
}

.panel-info-crc2 {
  border-color: #dc6800;
}

.panel-info-crc2 .panel-heading {
  color: #fefefe;
  background-color: #dc6800;
  border-color: #c90c5c;
}

.panel-primary .panel-heading {
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}

.list-group {
  padding-left: 0;
  margin-bottom: 20px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
  font-family: "Open sans", sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
}

.media-body,
.media-left,
.media-right {
  display: table-cell;
  vertical-align: top;
}

.media-body {
  width: 10000px;
}
.media,
.media-body {
  overflow: hidden;
  zoom: 1;
}

/*  Md Tofiq (B) 28-2-19 */
@media only screen and (max-width: 767px) {
  #aboutimg {
    width: 100%;
  }
}
#carouselExampleControls {
  display: none;
}
@media only screen and (max-width: 767px) {
  #flux {
    display: none;
  }
}
.w-100 {
  height: 300px;
}
@media only screen and (max-width: 767px) {
  .w-100 {
    height: 150px;
  }
  #carouselExampleControls {
    display: block;
  }
}

marquee p {
  display: inline;
  margin-right: 70px;
}
/* Md(E) */
</style>



// WEBPACK FOOTER //
// src/components/Home.vue